module.exports = __webpack_public_path__ + "img/gereg4.d630770c.jpg";